import {change, reduxForm, formValueSelector} from 'redux-form'
import { connect } from 'react-redux'
import {signLicenseRequest, nextLicensePage, toggleLicenseTypes, getLicenseAccess} from "../../actions/index";
import GeneratedLicenseInfo from "../../components/GeneratedLicenses/GeneratedLicenseInfo";

// Read live values from this wizard's form so the email-cascade can prune
// disallowed licenses and clamp the expiry against the current selection.
const selector = formValueSelector('generatedLicenseInfo')

const mapStateToProps = (state, ownProps) => {
    return {
        // request: state.license.request,
        // expireDate: state.license.expireDate
        initialValues: state.license,
        productCodes: state.license.productCodes,
        authInfo: state.auth,
        // Per-user entitlements (email -> company, allowed products, expiry)
        licenseAccess: state.licenseAccess.allLicenses,
        currentExpire: selector(state, 'expire_date'),
        currentLicenseTypes: selector(state, 'license_types')
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        signLicense: (expireDate, licenseTypes, licenseRequest, fullname, email, authEmail, companyName) => {
          return dispatch(signLicenseRequest(expireDate, licenseTypes, licenseRequest, fullname, email, authEmail, companyName))
        },

        getLicenseAccess: () => {
            return dispatch(getLicenseAccess())
        },

        toggleLicenseTypes: () => {
            return dispatch(toggleLicenseTypes())
        },
        updateLicenseRequest : (request) => {
            dispatch(change("license", "licenseHolder", request.licenseHolder))
            dispatch(change("license", "licenseCertificate", request.licenseCertificate))
        },
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GeneratedLicenseInfo);
